import { Component, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  standalone: false,
  selector: 'app-warning-login',
  templateUrl: './warning-login.component.html',
  styleUrls: ['./warning-login.component.scss']
})
export class WarningLoginComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<WarningLoginComponent>
    ) { }

  closeModal() {
    this.dialogRef.close();
  }
}



